module.exports = __webpack_public_path__ + "static/img/dkwps2-9.ba0eddc.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwps2-9.png
// module id = 408
// module chunks = 0